/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import {
  clearAllUserDataAction,
  masterNumberAction,
  plateNumberAction,
  screenLoadingAction,
  vehicleTypeAction,
  vinSerialNumberAction,
} from 'redux/actions'
import { processMasterNumberAction } from 'redux/reducers/apiReducers/processMasterNumberReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
import BackAnchor from '../../../../shared/components/BackAnchor'
import MasterNumber from './MasterNumber'
import PlateNumber from './PlateNumber'
import VinSerialNumber from './VinSerialNumber'
import styles from './YourInformation.module.scss'

const YourInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()

  const [masterNumberValid, setMasterNumberValid] = useState('')
  const [plateNumberValid, setPlateNumberValid] = useState('')
  const [vinSerialNumberValid, setVinSerialNumberValid] = useState('')
  const [errMsg, setErrMsg] = useState('')

  const [masterNumberError, setMasterNumberError] = useState('your_information.master_number_error')
  const [plateNumberError, setPlateNumberError] = useState('your_information.plate_number_error')
  const [vinSerialNumberError, setVinSerialNumberError] = useState('your_information.vin_serial_number_error')

  const { masterNumber, plateNumber, vinSerialNumber, permits, editPlateNumber, addressUpdate } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      if (editPlateNumber || permits.length === 0) {
        if (addressUpdate === '') {
          // history.push(`/${i18n.language}${t('routes.address_update_question')}`)
        } else {
          if (editPlateNumber) {
            let permit = permits.find((permitInfo) => permitInfo.plateNumber === editPlateNumber)
            dispatch(plateNumberAction(permit.plateNumber))
            dispatch(vinSerialNumberAction(permit.vinSerialNumber))
          }
        }
      } else {
        const holdMasterNumber = masterNumber,
          holdPlateNumber = plateNumber,
          holdVinSerialNumber = vinSerialNumber
        // dispatch(clearAllUserDataAction())
        dispatch(masterNumberAction(holdMasterNumber))
        dispatch(plateNumberAction(holdPlateNumber))
        dispatch(vinSerialNumberAction(holdVinSerialNumber))
        // history.push(`/${i18n.language}${t('routes.insurance_info')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const onAddPermit = () => {
    try {
      if (validateFields()) {
        setErrMsg('')
        dispatch(screenLoadingAction())
        dispatch(getServiceAvailableAction())
          .then((serviceAvailableRes) => {
            if (serviceAvailableRes['data']) {
              dispatch(processMasterNumberAction(masterNumber.toUpperCase(), plateNumber, vinSerialNumber))
                .then((res) => {
                  localStorage.setItem('plateNumber', plateNumber)
                  if (res['messageCode'] === 'OVPR000') {
                    if (res['vehicleData']['fisherman']) {
                      dispatch(vehicleTypeAction('fisherman'))
                      history.push(`/${i18n.language}${t('routes.eligibility_question_fishing')}`)
                    } else if (res['vehicleData']['farmer']) {
                      dispatch(vehicleTypeAction('farmer'))
                      history.push(`/${i18n.language}${t('routes.eligibility_question_farm')}`)
                    } else {
                      if (res['feeTerms'] && res['feeTerms'].length > 0) {
                        dispatch(vehicleTypeAction('regular'))
                        history.push(`/${i18n.language}${t('routes.renewal_period')}`)
                      } else {
                        history.push(`/${i18n.language}${t('routes.cannot_process_permit')}`)
                      }
                    }
                  } else {
                    history.push(`/${i18n.language}${t('routes.cannot_process_permit')}`)
                  }
                  dispatch(screenLoadingAction())
                })
                .catch((e) => {
                  setErrMsg('your_information.service_not_available_error')
                  console.log(e)
                  dispatch(screenLoadingAction())
                })
            } else {
              setErrMsg('your_information.service_not_available_error')
              dispatch(screenLoadingAction())
            }
          })
          .catch((err) => {
            console.log(err)
            setErrMsg('your_information.service_not_available_error')
            dispatch(screenLoadingAction())
          })
      }
    } catch (e) {
      console.log(e)
      setErrMsg('your_information.service_not_available_error')
    }
  }

  const validateFields = () => {
    try {
      let masterValid = false,
        plateValid = false,
        vinValid = false
      if (masterNumber === '') {
        setMasterNumberValid(masterValid)
      } else {
        masterValid = validateMasterNumber(masterNumber)
      }
      if (plateNumber === '') {
        setPlateNumberValid(plateValid)
      } else {
        plateValid = validatePlateNumber(plateNumber)
      }
      if (vinSerialNumber === '') {
        setVinSerialNumberValid(vinValid)
      } else {
        vinValid = validateVinSerialNumber(vinSerialNumber)
      }
      return masterValid && plateValid && vinValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePermitExist = (permit) => {
    try {
      if (editPlateNumber === permit) {
        return false
      }
      return permits.find((permitInfo) => permitInfo.plateNumber === permit)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateVINExist = (vin) => {
    try {
      return permits.find((permitInfo) => permitInfo.vinSerialNumber === vin && permitInfo.plateNumber !== editPlateNumber)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateMasterNumber = (masterNumberElem) => {
    let masterValid = false,
      masterError = ''
    const regex = RegExp(/^[a-zA-Z0-9 ]{14}$/i)
    const lettersRegex = RegExp(/^[a-zA-Z ]{5}$/i)
    if (masterNumberElem.length > 0) {
      let nameMasterNumber = masterNumberElem.substring(0, 5)
      if (regex.test(masterNumberElem) && lettersRegex.test(nameMasterNumber) && !isNaN(masterNumberElem.substring(5))) {
        masterValid = true
      } else {
        masterError = 'your_information.master_number_error_invalid'
      }
    } else {
      masterError = 'your_information.master_number_error'
    }
    setMasterNumberValid(masterValid)
    setMasterNumberError(masterError)
    return masterValid
  }

  const validatePlateNumber = (plate) => {
    try {
      let plateValid = false,
        plateError = ''
      const regex = RegExp(/^[a-z0-9]{2,7}$/i)
      if (regex.test(plate)) {
        if (validatePermitExist(plate)) {
          plateError = 'your_information.permit_exists'
        } else {
          plateValid = true
        }
      } else {
        plateError = 'your_information.plate_number_error'
      }
      setPlateNumberValid(plateValid)
      setPlateNumberError(plateError)
      return plateValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateVinSerialNumber = (number) => {
    try {
      let vinValid = false,
        vinError = ''
      const regex = RegExp(/^[a-z0-9]{1,4}$/i)
      if (regex.test(number)) {
        if (validateVINExist(number)) {
          vinError = 'your_information.vin_exists'
        } else {
          vinValid = true
        }
      } else {
        vinError = 'your_information.vin_serial_number_error'
      }
      setVinSerialNumberValid(vinValid)
      setVinSerialNumberError(vinError)
      return vinValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const formInfoSection = (
    <div className="row">
      <div className="col-xs-12 col-lg-9">
        <div
          style={{
            display: 'flex',
            padding: '0 10px 10px',
            borderRadius: '5px',
            border: '1px solid #0058a4',
            alignItems: 'center',
            background: '#bfd5e8',
            marginBottom: '15px',
            gap: '10px',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            fill="currentColor"
            class="bi bi-info-circle-fill"
            viewBox="0 0 16 16"
            style={{ color: '#0058a4' }}
          >
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
          </svg>
          <p className="ns-phase-banner__content">
            <h5>
              {t('your_information.peeling_plate_1')}
              <br />
              {t('your_information.peeling_plate_2')}
              <br />
              {t('your_information.peeling_plate_3')}
              <a href={t('your_information.peeling_plate_url')} target="_blank">
                {t('your_information.peeling_plate_link')}
              </a>
            </h5>
          </p>
        </div>
      </div>
    </div>
  )

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <BackAnchor backPath="routes.fines_question" />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{t('your_information.add_your_info')}</h1>
        </div>
      </div>
      {formInfoSection}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <MasterNumber
            validateMasterNumber={validateMasterNumber}
            masterNumberError={masterNumberError}
            masterNumberValid={masterNumberValid}
            isDisabled={permits.length > 0}
            setIsError={setIsError}
          />
          <PlateNumber
            validatePlateNumber={validatePlateNumber}
            plateNumberError={plateNumberError}
            plateNumberValid={plateNumberValid}
            setIsError={setIsError}
          />
          <VinSerialNumber
            validateVinSerialNumber={validateVinSerialNumber}
            vinSerialNumberError={vinSerialNumberError}
            vinSerialNumberValid={vinSerialNumberValid}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className={styles['error_margin']} style={{ marginTop: '30px' }}>
        <button style={{ margin: 0 }} className="btn-lg btn-primary" onClick={onAddPermit}>
          {t('shared.next_step')}
        </button>
      </div>
      {errMsg !== '' && (
        <div className={styles['error_message']}>
          <div className="form-group has-error">
            <i className={['fa fa-exclamation-circle', styles['exclamation_position']].join(' ')} aria-hidden="true" />
            <div className="help-block">{t(errMsg)}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withTranslation('common')(YourInformationView)
